// extracted by mini-css-extract-plugin
export default {"logsHeader":"EventLogView_logsHeader__gJn9s","logs":"EventLogView_logs__0pUSN","logColumn":"EventLogView_logColumn__ygkKP"};